import r from "./_baseIsNative.js";
import i from "./_getValue.js";
function f(t, a) {
  var e = i(t, a);
  return r(e) ? e : void 0;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getNative.js
// module id = 179
// module chunks = 67